import React, { useEffect, createElement } from 'react';
import AdvertorialGlpAdv4 from '../components/AdvertorialGlpAdv4';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpAdv4Page() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv2
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Ozempic Depression Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking - NEW CUSTOM EVENTS
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18495" data-mp="1kt0l27yvk7ee">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18496" data-mp="1ktirfxf94201">
        <Helmet data-id="element-18497" data-mp="1oshrb3m4l8km">
          <title data-id="element-18498" data-mp="1ot1asorfc50r">
            Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users
            Experiencing Severe Depression—And Why Isn't Anyone Talking About
            It?
          </title>
          <meta property="og:title" content="Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users Experiencing Severe Depression—And Why Isn't Anyone Talking About It?" data-id="element-18499" data-mp="1ys8m76ellpl8" />
          <meta property="og:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18500" data-mp="4er80a03252v" />
          <meta property="og:type" content="article" data-id="element-18501" data-mp="2hvtx2w4fkhwg" />
          <meta property="og:url" content={window.location.href} data-id="element-18502" data-mp="2hu959e9i3d2a" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18503" data-mp="2dv0bi9egnf6q" />
          <meta property="og:image:width" content="1200" data-id="element-18504" data-mp="35lo8rad0k0f4" />
          <meta property="og:image:height" content="630" data-id="element-18505" data-mp="35l4uc3mknu5u" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18506" data-mp="31jjmwxst4831" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18507" data-mp="2wkzzsu2h8q93" />
          <meta name="twitter:title" content="Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users Experiencing Severe Depression—And Why Isn't Anyone Talking About It?" data-id="element-18508" data-mp="2wj5cxa7nao2d" />
          <meta name="twitter:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18509" data-mp="1l6mcbqbmyctl" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18510" data-mp="38v6cgjac550k" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18511" data-mp="2v2zwoyb3h01n" />
        </Helmet>
        <AdvertorialGlpAdv4 data-id="element-18512" data-mp="3022qfmlmjjub" />
      </div>
    </HelmetProvider>;
}